import { type OpenApiSchemaImportStocksSettings } from '../../api/schema';
import { INTEGRATION_TYPE_OZON_DELIVERY_FBS, INTEGRATION_TYPE_OZON_FBO_PLUS } from './constants';

export function checkChosenOzonLogisticFboIntegrationSubType(subTypes: OpenApiSchemaImportStocksSettings['sub_types']) {
    return subTypes !== undefined && subTypes.some((subType) => subType.sub_type === INTEGRATION_TYPE_OZON_FBO_PLUS);
}

export function checkChosenOzonLogisticFbsIntegrationSubType(subTypes: OpenApiSchemaImportStocksSettings['sub_types']) {
    return (
        subTypes !== undefined && subTypes.some((subType) => subType.sub_type === INTEGRATION_TYPE_OZON_DELIVERY_FBS)
    );
}
